<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            预工单列表
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <el-button type="primary" plain @click.native="toggleModalAdd">订单操作</el-button>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;">
                        <el-table-column prop="elderlyDTO.name" label="姓名" width="150"></el-table-column>
                        <el-table-column prop="elderlyDTO.zoneName" label="所属区域" width="150"></el-table-column>
                        <el-table-column prop="listOrderGoodsDTO[0].goodsName" label="标题" width="150"></el-table-column>
                        <el-table-column prop="listOrderGoodsDTO[0].goodsImg" label="商品图片" width="100">
                            <template slot-scope="scope">
                                <el-popover placement="right" title="" trigger="click" v-if="scope.row.listOrderGoodsDTO[0].goodsImg">
                                    <img :src="imgUrl+scope.row.listOrderGoodsDTO[0].goodsImg"  style="width: 500px"/>
                                    <img slot="reference" :src="imgUrl+scope.row.listOrderGoodsDTO[0].goodsImg" style="width:100%">
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="listOrderGoodsDTO[0].goodsPrice" label="销售价（元）"></el-table-column>
                        <el-table-column prop="listOrderGoodsDTO[0].number" label="购买数量"></el-table-column>
                        <el-table-column prop="listOrderGoodsDTO[0].planTime" :formatter="timefilter" width="200" label="预约时间"></el-table-column>
                        <el-table-column
                                prop="status"
                                :formatter="statuss"
                                label="订单状态">
                        </el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:zoneValue="zoneValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import Add from "./Add";
    import {getStaffCode, getStaffDTO} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                zoneValue:[],
                idNumber:'',
                phone:'',
                totalItems: 0,
                pageSize:20,
                imgUrl:this.$imgUrl,
                currentPage:1,
                th:0,
                name:'',
            }
        },
        components:{
            Add
        },
        created(){
            this.getList();
            this.init();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Zone/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        var data=JSON.stringify(response.data.data);
                        data=JSON.parse(data.replace(/"listZoneDTO":\[\],/g,''))
                        this.zoneValue = data;
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                })
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            //日期格式
            timefilter(row){
                return timefilters(row.listOrderGoodsDTO[0].planTime)
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            statuss(row, column, cellValue){
                return this.allStatus(cellValue,['待付款','待发货','待收货','交易成功','退款中','交易关闭','交易取消','已评价',"","",'待付款','待接单','已接单','服务中','服务完成','交易取消','已评价']);
            },
            allStatus(row,status){
                for(var i in status){
                    if(i==row){
                        return status[i]
                    }
                }
                return "其它";
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"OrderBusiness/PageForStaffServeSchedule",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                        zoneCode:getStaffDTO().zoneCode
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.pageInfoOrderBusinessDTO.list;
                        this.totalItems = response.data.data.pageInfoOrderBusinessDTO.total;
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
        }
    }
</script>

<style scoped>

</style>
